"use client";

import { ConfirmDialog } from "@/components/ui/confirm-dialog";
import { useLoginModal } from "@/contexts/login-modal-context";
import {
    hasShownLoginExpiredNotification,
    resetLoginExpiredNotification,
    subscribeLoginExpired,
} from "@/lib/login-expired-notifier";
import { ConnectManager, SOCKET_KEY } from "@yn/socket";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

export function LoginExpiredDialog() {
    const { open: isLoginModalOpen, openModal } = useLoginModal();
    const pathname = usePathname();
    const pathnameRef = useRef( pathname );
    const [ open, setOpen ] = useState( hasShownLoginExpiredNotification() );

    useEffect( () => {
        if ( pathname === "/invitee-sign-in" ) {
            resetLoginExpiredNotification();
            setOpen( false );
        }

        pathnameRef.current = pathname;
    }, [ pathname ] );

    useEffect( () => {
        const unsubscribe = subscribeLoginExpired(
            () => {
                if ( pathnameRef.current === "/invitee-sign-in" || isLoginModalOpen ) {
                    resetLoginExpiredNotification();
                    return;
                }
                // 登录过期时立即清除 WebSocket 中的 userId，
                // 后续心跳 ping 将不再携带 uid，避免发送过期身份信息
                ConnectManager.getInstance( SOCKET_KEY.ORDERBOOK ).setUserId( undefined );
                setOpen( true );
            },
            { immediate: true },
        );

        return () => unsubscribe();
    }, [ isLoginModalOpen, openModal ] );

    useEffect( () => {
        if ( !isLoginModalOpen ) return;
        resetLoginExpiredNotification();
        setOpen( false );
    }, [ isLoginModalOpen ] );

    const handleOpenChange = ( nextOpen: boolean ) => {
        if ( !nextOpen ) {
            resetLoginExpiredNotification();
        }
        setOpen( nextOpen );
    };

    const handleConfirm = () => {
        resetLoginExpiredNotification();
        setOpen( false );
        openModal( "expired" );
    };

    return (
        <ConfirmDialog
            open={open}
            onOpenChange={handleOpenChange}
            title="Session expired"
            description="You are not logged in or your session has expired. Please log in again."
            confirmText="OK"
            cancelText="Cancel"
            onConfirm={handleConfirm}
        />
    );
}
